/* Averon theme layer: small progressive enhancements, no dependencies. */

function initTableHints() {
  const wraps = document.querySelectorAll('.averon-table-wrap');
  wraps.forEach((wrap) => {
    const hint = wrap.previousElementSibling;
    if (!hint || !hint.classList.contains('averon-table__hint')) return;
    const update = () => {
      const scrollable = wrap.scrollWidth > wrap.clientWidth + 2;
      hint.hidden = !scrollable;
    };
    update();
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(wrap);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
  });
}

function initFaqDeepLinks() {
  const hash = window.location.hash;
  if (!hash || hash.length < 2) return;
  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (target && target.tagName === 'DETAILS') {
    target.open = true;
  }
}


/* Scroll-Reveal: markiert Marketing-Bloecke und blendet sie beim Eintritt ein.
   Laeuft nur mit JS -> ohne JS bleibt alles sichtbar. Feuert einmal pro Element. */
var AV_REVEAL_GROUPS = [
  '.averon-promise__item',
  '.averon-section__head',
  '.averon-pricing__grid > *',
  '.averon-pricing__footer',
  '.averon-demos__grid > *',
  '.averon-demos__all',
  '.averon-steps__list > *',
  '.averon-included__col',
  '.averon-table-wrap',
  '.averon-faq__group-title',
  '.averon-faq__item',
  '.averon-founder',
  '.averon-final__text',
  '.averon-final__aside',
  '.averon-addons__grid > *',
  '.averon-demo-detail__item',
  '.averon-content__block'
];

function initReveal() {
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.setAttribute('data-av-visible', '');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  // Sicherheitsnetz: falls der Observer nie feuert (exotischer Browser, Tab nie
  // sichtbar), nach 2.5s alles einblenden. Lieber ohne Animation als unsichtbar.
  window.setTimeout(function () {
    document.querySelectorAll('.av-reveal:not([data-av-visible])').forEach(function (node) {
      node.setAttribute('data-av-visible', '');
    });
  }, 2500);

  AV_REVEAL_GROUPS.forEach(function (selector) {
    var nodes = document.querySelectorAll(selector);
    nodes.forEach(function (node, index) {
      if (node.classList.contains('av-reveal')) return;
      if (node.closest('.averon-hero')) return; // above the fold bleibt statisch
      node.classList.add('av-reveal');
      // Stagger nur innerhalb einer Gruppe, gedeckelt damit spaete Karten nicht haengen
      node.style.setProperty('--av-i', String(Math.min(index, 5)));
      observer.observe(node);
    });
  });
}

/* Signal fuer CSS: erst mit JS wird aus dem nativen <select> das eigene Dropdown. */
document.documentElement.classList.add('av-js');

var AV_CONSENT_TEXT =
  'Sofortiger Beginn ausdrücklich verlangt, Erlöschen nach vollständiger Lieferung bestätigt';

/* Eigenes Dropdown (Paket + Nische). Das native <select> bleibt die Quelle der Wahrheit,
   damit Horizons variant-picker weiter greift. Alles delegiert, weil Horizon den Picker
   bei jedem Variantenwechsel neu rendert - so muss nichts neu gebunden werden. */
function avCloseSelects(except) {
  document.querySelectorAll('.averon-select.is-open').forEach(function (root) {
    if (root === except) return;
    root.classList.remove('is-open');
    var t = root.querySelector('[data-av-select-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  });
}

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-av-select-trigger]');
  if (trigger) {
    var root = trigger.closest('.averon-select');
    avCloseSelects(root);
    var isOpen = root.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    return;
  }

  var option = event.target.closest('[data-av-select-option]');
  if (!option) {
    avCloseSelects(null);
    return;
  }
  if (option.disabled) return;

  var host = option.closest('.averon-select');
  var native = host.querySelector('select');
  avCloseSelects(null);
  if (native && native.value !== option.dataset.value) {
    native.value = option.dataset.value;
    native.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') avCloseSelects(null);
});

/* Widerrufs-Nachweis (§ 356 Abs. 6 BGB), Fassung ohne Checkbox: Der Hinweis
   steht sichtbar am Kaufweg (snippets/averon-consent.liquid), die Zustimmung
   liegt in der Bestellung selbst. Hier wird beim Klick auf einen Kauf-Button
   der Nachweis angehaengt: als Bestell-Attribut fuer den normalen Checkout und
   als Line-Item-Property fuer Express-Buttons, die den Warenkorb ueberspringen.
   Nichts blockiert, nichts wird abgefangen. */
document.addEventListener(
  'click',
  function (event) {
    var trigger = event.target.closest(
      '#checkout, button[name="checkout"], .shopify-payment-button, [class*="accelerated-checkout"]'
    );
    if (!trigger) return;

    var form = trigger.closest('form[data-type="add-to-cart-form"], product-form-component form');
    if (form && !form.querySelector('input[name="properties[Widerrufsrecht]"]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Widerrufsrecht]';
      hidden.value = AV_CONSENT_TEXT;
      form.appendChild(hidden);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Widerrufsrecht: AV_CONSENT_TEXT } }),
    }).catch(function () {});
  },
  true
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initTableHints();
    initFaqDeepLinks();
    initReveal();
  });
} else {
  initTableHints();
  initFaqDeepLinks();
  initReveal();
}

document.addEventListener('shopify:section:load', function () {
  initTableHints();
  initReveal();
});
